module.exports = __webpack_public_path__ + "media/6.97c97dd4.wav";